/* AFS B2B — quick order: paste SKUs, manual rows, CSV upload, validation
   against the predictive search API (exact-identifier match), add all to cart
   or quote list, save as list, error report download.
   Authoritative catalog-scale SKU resolution requires the bulk-order
   integration (see docs/GAPS_AND_PLATFORM_DEPENDENCIES.md). */
(function () {
  'use strict';

  var root = document.getElementById('QuickOrder');
  if (!root) return;

  var cfg = window.AFSConfig || { routes: {}, pages: {} };
  var tbody = root.querySelector('[data-qo-rows]');
  var rowTemplate = document.getElementById('QuickOrderRowTemplate');
  var state = []; // { sku, qty, poLine, status, variant }

  function addRow(data) {
    data = data || { sku: '', qty: 1, poLine: '' };
    var frag = rowTemplate.content.cloneNode(true);
    var tr = frag.querySelector('tr');
    tr.querySelector('[data-qo-sku]').value = data.sku;
    tr.querySelector('[data-qo-qty]').value = data.qty;
    var po = tr.querySelector('[data-qo-po]');
    if (po) po.value = data.poLine || '';
    tbody.appendChild(frag);
    return tr;
  }

  function readRows() {
    return Array.prototype.slice.call(tbody.querySelectorAll('tr')).map(function (tr) {
      return {
        tr: tr,
        sku: tr.querySelector('[data-qo-sku]').value.trim(),
        qty: Math.max(1, parseInt(tr.querySelector('[data-qo-qty]').value, 10) || 1),
        poLine: (tr.querySelector('[data-qo-po]') || { value: '' }).value.trim()
      };
    }).filter(function (r) { return r.sku; });
  }

  function setRowStatus(tr, cls, text) {
    var cell = tr.querySelector('[data-qo-status]');
    cell.className = 'qo-row-status qo-row-status--' + cls;
    cell.setAttribute('data-qo-status', '');
    cell.textContent = text;
  }

  /* Exact-identifier lookup via predictive search (variant SKU field). */
  function lookupSku(sku) {
    /* The .json suffix is required: /search/suggest without it returns HTML. */
    var url = cfg.routes.predictiveSearch + '.json' +
      '?q=' + encodeURIComponent(sku) +
      '&resources[type]=product&resources[limit]=6' +
      '&resources[options][fields]=variants.sku,variants.barcode,title,variants.title';
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('lookup_failed:' + res.status);
        return res.json();
      })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        for (var p = 0; p < products.length; p++) {
          var prod = products[p];
          var variants = prod.variants || [];
          for (var v = 0; v < variants.length; v++) {
            if ((variants[v].sku || '').toUpperCase() === sku.toUpperCase()) {
              return {
                variantId: variants[v].id,
                available: variants[v].available !== false,
                title: prod.title,
                url: prod.url,
                image: (prod.featured_image && prod.featured_image.url) || ''
              };
            }
          }
        }
        return null;
      });
  }

  function validateAll() {
    var rows = readRows();
    var chain = Promise.resolve();
    rows.forEach(function (row) {
      chain = chain.then(function () {
        setRowStatus(row.tr, 'warn', '…');
        return lookupSku(row.sku).then(function (variant) {
          if (!variant) {
            row.status = 'not_found';
            setRowStatus(row.tr, 'error', root.getAttribute('data-t-notfound'));
          } else if (!variant.available) {
            row.status = 'unavailable';
            row.variant = variant;
            setRowStatus(row.tr, 'warn', root.getAttribute('data-t-unavailable'));
          } else {
            row.status = 'ok';
            row.variant = variant;
            setRowStatus(row.tr, 'ok', root.getAttribute('data-t-found') + ' — ' + variant.title);
          }
        }).catch(function () {
          /* A network/parse failure is not the same as a bad SKU — never tell a
             buyer their part number is wrong when the lookup itself failed. */
          row.status = 'lookup_failed';
          setRowStatus(row.tr, 'warn', 'Could not check this SKU — retry');
        });
      });
    });
    return chain.then(function () { state = rows; return rows; });
  }

  function parsePasted(text) {
    text.split(/\r?\n/).forEach(function (line) {
      line = line.trim();
      if (!line) return;
      var parts = line.split(/[,;\t]+/).map(function (s) { return s.trim(); });
      if (!parts[0]) return;
      addRow({ sku: parts[0], qty: parseInt(parts[1], 10) || 1, poLine: parts[2] || '' });
    });
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-qo-add-row]')) { addRow().querySelector('[data-qo-sku]').focus(); }

    if (e.target.closest('[data-qo-remove-row]')) {
      e.target.closest('tr').remove();
    }

    if (e.target.closest('[data-qo-parse]')) {
      var ta = root.querySelector('[data-qo-paste]');
      if (ta && ta.value.trim()) { parsePasted(ta.value); ta.value = ''; }
    }

    if (e.target.closest('[data-qo-validate]')) validateAll();

    if (e.target.closest('[data-qo-add-cart]')) {
      validateAll().then(function (rows) {
        var ok = rows.filter(function (r) { return r.status === 'ok'; });
        if (!ok.length) return;
        var items = ok.map(function (r) {
          var props = r.poLine ? { properties: { 'PO line': r.poLine } } : {};
          return Object.assign({ id: r.variant.variantId, quantity: r.qty }, props);
        });
        window.AFSCart.add(items).then(function () {
          window.AFSToast(root.getAttribute('data-t-added-cart'), { tone: 'success', linkHref: cfg.routes.cart, linkText: 'View cart' });
          ok.forEach(function (r) { r.tr.remove(); });
        }).catch(function (err) {
          window.AFSToast((err && err.description) || 'Some items could not be added.', { tone: 'error' });
        });
      });
    }

    if (e.target.closest('[data-qo-add-quote]')) {
      validateAll().then(function (rows) {
        var addable = rows.filter(function (r) { return r.variant; });
        addable.forEach(function (r) {
          window.AFSB2B.Quote.add({
            handle: '', variantId: r.variant.variantId, title: r.variant.title,
            sku: r.sku, url: r.variant.url, image: r.variant.image, uom: ''
          }, r.qty);
        });
        if (addable.length) {
          window.AFSToast(root.getAttribute('data-t-added-quote'), { tone: 'success', linkHref: cfg.pages.quote, linkText: 'View quote list' });
        }
      });
    }

    if (e.target.closest('[data-qo-save-list]')) {
      validateAll().then(function (rows) {
        var addable = rows.filter(function (r) { return r.variant; });
        if (!addable.length) return;
        var name = window.prompt(root.getAttribute('data-t-listname'));
        if (!name) return;
        var id = window.AFSB2B.Lists.create(name.trim());
        if (!id) return;
        addable.forEach(function (r) {
          window.AFSB2B.Lists.addItem(id, {
            handle: '', variantId: r.variant.variantId, title: r.variant.title,
            sku: r.sku, url: r.variant.url, image: r.variant.image, uom: ''
          }, r.qty);
        });
        window.AFSToast(root.getAttribute('data-t-saved-list'), { tone: 'success', linkHref: cfg.pages.savedLists, linkText: 'View lists' });
      });
    }

    if (e.target.closest('[data-qo-download-errors]')) {
      var bad = state.filter(function (r) { return r.status && r.status !== 'ok'; });
      if (!bad.length) return;
      var csv = 'sku,quantity,status\n' + bad.map(function (r) {
        return '"' + r.sku.replace(/"/g, '""') + '",' + r.qty + ',' + r.status;
      }).join('\n');
      var blob = new Blob([csv], { type: 'text/csv' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'quick-order-errors.csv';
      a.click();
      URL.revokeObjectURL(a.href);
    }
  });

  var fileInput = root.querySelector('[data-qo-file]');
  if (fileInput) {
    fileInput.addEventListener('change', function () {
      var file = fileInput.files && fileInput.files[0];
      if (!file) return;
      var reader = new FileReader();
      reader.onload = function () {
        var text = String(reader.result || '');
        // Skip a header row like "sku,quantity"
        var lines = text.split(/\r?\n/);
        if (lines.length && /sku/i.test(lines[0]) && /qty|quantity/i.test(lines[0])) lines.shift();
        parsePasted(lines.join('\n'));
      };
      reader.readAsText(file);
      fileInput.value = '';
    });
  }

  // Start with three empty rows
  addRow(); addRow(); addRow();
})();
